<script lang="ts">
    import Icon from '@iconify/svelte'

    import { gettext as _ } from 'hydria/services/gettext'
</script>

<Icon inline icon="fa:history" /><span class="d-none d-lg-inline">&nbsp;&nbsp;{$_('Previous revisions')}</span>
